document.addEventListener('DOMContentLoaded', () => {
  if (window.innerWidth <= 768) {
    const form = document.querySelector('form[action="/cart/add"]')
    let productBlock = null
    let productData = null
    if (form) {
      productBlock = form.closest('.product-block')
      productData = JSON.parse(productBlock.querySelector('.product-block-json').textContent)
      form.remove()
    }
    let selectedColor = Array.from(document.querySelectorAll('.variant__input--color-swatch')).find(color => color.checked).value

    //console.log('xxx Load productData:', productData)
    //console.log('xxx Load selectedColor:', selectedColor)
    //console.log('xxx productBlock:', productBlock)

    initSelector(productData, selectedColor, productBlock)

    document.addEventListener('variant:change', () => {
      // console.log('xxx variant:change') this is for mobile only on PDP
      selectedColor = Array.from(document.querySelectorAll('.variant__input--color-swatch')).find(color => color.checked).value
      initSelector(productData, selectedColor, productBlock)

    }) // End variant:change
  } // End window width condition
}) // End DOMContentLoaded

function initSelector(productData, selectedColor, productBlock) {
  let isOneSize = false
  let oneSizeAvailable = true
  //console.log('xxx productData variants:', productData.variants.find(variant => variant.option2 === 'O/S'))
  productData.variants.forEach(variant => {
    if (variant.option2 === 'O/S') {
      isOneSize = true
      if (!variant.available) {
        oneSizeAvailable = false
      }
    }
  })

  const selectorTrigger = document.getElementById('size-selector-trigger')
  const selectorContent = document.getElementById('size-selector-content')

  // Remove existing size selectors
  if (selectorTrigger) selectorTrigger.remove()
  if (selectorContent) selectorContent.remove()

  productBlock.classList.add('fixed-product-block')

  // Create new Size Selector Trigger
  const sizeSelectorTrigger = document.createElement('button')

  if (isOneSize) {
    sizeSelectorTrigger.id = 'one-size-selector-trigger'
    sizeSelectorTrigger.textContent = 'Add to Cart'
    sizeSelectorTrigger.className = 'btn btn--full add-to-cart disabled-true'
  } else {
    sizeSelectorTrigger.id = 'size-selector-trigger'
    sizeSelectorTrigger.textContent = 'Select a Size'
    sizeSelectorTrigger.className = 'btn btn--full add-to-cart disabled-false'
  }

  // Append Size Selector elements to Product Block
  productBlock.appendChild(sizeSelectorTrigger)

  if (!isOneSize) {
    // Create new Size Selector Content Wrapper
    const sizeSelectorContent = document.createElement('div')
    sizeSelectorContent.id = 'size-selector-content'
    sizeSelectorContent.className = 'size-selector-content'

    // Create Size Buttons - Create sizes for selected color only
    const sizeOptions = productData.variants
      .filter(variant => variant.option1 === selectedColor)
      .map(variant => ({
        size: variant.option2,
        available: variant.available
      }))

    let html = ''

    sizeOptions.forEach(size => {
      // console.log('xxx size:', size)
      const value = size.size
      const oos = !size.available
      const oosClass = ` disabled-${oos}`
      const sizeButtonHTML = `
        <button type="button" class="size-selector-button${oosClass}" data-value="${value}">${value}</button>
      `
      html = html + sizeButtonHTML
    })

    // Insert HTML to Content Wrapper
    sizeSelectorContent.innerHTML = html

    productBlock.appendChild(sizeSelectorContent)

    // Add event listener to trigger
    sizeSelectorTrigger.addEventListener('click', () => {
      sizeSelectorContent.classList.toggle('selector-open')
    })

    // Add event listener to document to close selector
    document.addEventListener('click', (e) => {
      const trigger = document.getElementById('size-selector-trigger')
      const content = document.getElementById('size-selector-content')
      const isContentOpen = content.classList.contains('selector-open')
      const isClickInsideContent = content.contains(e.target)
      const isTrigger = trigger.contains(e.target)

      if (!isClickInsideContent && !isTrigger && isContentOpen) {
        e.preventDefault()
        e.stopPropagation()
        content.classList.remove('selector-open')
      }
    })

    // Add event listener for Size Option Buttons
    const buttons = document.querySelectorAll('.size-selector-button')
    if (buttons.length > 0) {
      buttons.forEach(button => {
        button.addEventListener('click', () => {
          const value = button.getAttribute('data-value')
          const matchingVariant = productData.variants.find(variant => variant.option1 === selectedColor && variant.option2 === value)

          if (matchingVariant) {
            //console.log('xxx matchingVariant:', matchingVariant)
            const variantId = matchingVariant.id
            const selectedQty = 1

            // Add to cart fetch
            const formData = {
              items: [{
                id: variantId,
                quantity: selectedQty
              }]
            };

            fetch('/cart/add.js', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
              },
              body: JSON.stringify(formData)
            })
            .then(() => {
              const content = document.getElementById('size-selector-content')
              if (content.classList.contains('selector-open')) {
                content.classList.remove('selector-open')
              }
              const cartBuildEvent = new CustomEvent('cart:build')
              const cartOpenEvent = new CustomEvent('cart:open')
              document.dispatchEvent(cartBuildEvent)
              document.dispatchEvent(cartOpenEvent)
            })
            .catch(error => {
              console.error('Error:', error);
            });
          }
        })
      })
    }
  } else {
    const trigger = document.getElementById('one-size-selector-trigger')
    trigger.addEventListener('click', () => {
      const matchingVariant = productData.variants.find(variant => variant.option1 === selectedColor && variant.option2 === 'O/S')

      if (matchingVariant) {
        //console.log('xxx matchingVariant:', matchingVariant)
        const variantId = matchingVariant.id
        const selectedQty = 1

        // Add to cart fetch
        const formData = {
          items: [{
            id: variantId,
            quantity: selectedQty
          }]
        };

        fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify(formData)
        })
        .then(() => {
          const cartBuildEvent = new CustomEvent('cart:build')
          const cartOpenEvent = new CustomEvent('cart:open')
          document.dispatchEvent(cartBuildEvent)
          document.dispatchEvent(cartOpenEvent)
        })
        .catch(error => {
          console.error('Error:', error);
        });
      }
    })
  }

}